import { Button, Checkbox, Dialog } from 'braid-design-system';

import type { FormValues } from 'src/pages/manage/security-breach/SecurityBreach';

interface IntergrationTerminationDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  confirmTermination: boolean;
  setConfirmTermination: (confirm: boolean) => void;
  values: FormValues;
  submit: (values: FormValues) => void;
}

export const TerminationConfirmationDialog = ({
  open,
  setOpen,
  confirmTermination,
  setConfirmTermination,
  values,
  submit,
}: IntergrationTerminationDialogProps) => (
  <Dialog
    id="integration-termination-dialog"
    title="Integration Pause"
    open={open}
    onClose={() => setOpen(false)}
  >
    <Checkbox
      id="security-breach-confirm-termination"
      checked={confirmTermination}
      label="I acknowledge that this will put my integration and ALL my SEEK services on hold until the details are reviewed by
      SEEK during ANZ business hours."
      onChange={() => setConfirmTermination(!confirmTermination)}
    />
    <Button
      tone="critical"
      id="security-breach-submit-termination"
      onClick={() => {
        if (!confirmTermination) {
          return;
        }
        return submit(values);
      }}
    >
      {'Submit & Terminate'}
    </Button>
  </Dialog>
);
